<template>
  <div id="app">
    <!-- 路由导航（可选） -->
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link target="_blank" to="/Login">Login</router-link>
    </nav> -->
    
    <!-- 路由视图 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 添加一些基本样式 */
nav {
  z-index: 10;
  padding: 20px;
  text-align: center;
}

nav a {
  margin: 0 10px;
  text-decoration: none;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
  font-weight: bold;
}
</style>